import styled from '@emotion/styled';
import { theme } from 'style';

export const Divider = styled.div`
  border-bottom: 1px solid ${theme.colors.lightGrey};
  margin-top: 20px;
`;
